/**
 * created by xcc
 * 字段表
 */
import React from "react";
import {Modal, Button} from "antd";
import BaseComponent from "../../../../../../base/BaseComponent";
import Scrollbars from 'react-custom-scrollbars';
import TableTemplate from "../../../../components/TableTemplate/TableTemplate";
import {generateColumns, getMaxWidth} from "../../../../../newMediaMatrix/components/utils";
import copy from 'copy-to-clipboard';
import {message} from "../../../../../../utils/message";

const fieldsTable = [
    {
        title: "备案表",
        type: 1,
        key: "recordTable",
    },
    // {
    //     title: "附加信息",
    //     type: 2,
    //     key: "additionalInfo",
    // },
]

export default class FieldsTable extends BaseComponent {
    static defaultProps = {
        viewAll: false,
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            groupedData: {},
        };
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    getColumns() {
        const {viewAll} = this.props;
        const baseColumns = [
            {
                title: "字段名称",
                dataIndex: "value",
                key: "value",
                ellipsis: true
            },
            {
                title: "键",
                dataIndex: "key",
                key: "key",
                ellipsis: true
            },
            {
                title: "操作",
                dataIndex: "operation",
                key: "operation",
                width: 250,
                render: (text, record) => {
                    return (
                        <>
                                <span style={{color: "#0050B3", marginRight: 10, cursor: "pointer"}}
                                      onClick={() => this.copyText(record.value)}>复制名称</span>
                            <span style={{color: "#0050B3", cursor: "pointer", marginRight: 10}}
                                  onClick={() => this.copyText(record.key)}>复制键</span>
                            <span style={{color: "#0050B3", cursor: "pointer", marginRight: 10}}
                                  onClick={() => this.copyText(record.value + "：" + record.key)}>复制全部</span>
                        </>
                    );
                }
            }
        ]
        const dynamicColumns = [
            {
                key: 'typeName',
                dataIndex: "typeName",
                ellipsis: true,
                title: '类型',
                checkFunction: () => viewAll,
                position: 2,
                width: 100,
                render: (text, record) => {
                    return record.type === 2 ? record.activityName : text;
                }
            }
        ];
        return generateColumns(baseColumns, dynamicColumns)
    }

    // 备案表展示的是type为1，3，4的数据
    showRecordDataByType = ['1', '3', '4'];

    viewFieldsTable = (record) => {
        this.request({
            url: '/cm-sites-media-consumer/system/positionType/getRecordFormTemplate',
            body: {
                id: record?.id || ""
            },
            callBack: (data) => {
                let groupedData = {};
                let specialCaseData = [];
                if (data && data.length) {
                    groupedData = data.reduce((accumulator, current) => {
                        if (!accumulator[current.type]) {
                            accumulator[current.type] = [];
                        }
                        accumulator[current.type].push(current);
                        return accumulator;
                    }, {});
                    this.showRecordDataByType.forEach(type => {
                        if (groupedData[type]) {
                            specialCaseData = specialCaseData.concat(groupedData[type]);
                        }
                    });
                    groupedData['1'] = specialCaseData;
                }
                this.setState({
                    groupedData,
                    visible: true,
                    positionItem: record,
                });
            },
            errorCallBack: (e) => {
            },
        })
    }

    //复制
    copyText = (url) => {
        copy(url);
        message.success('复制成功');
    };

    renderFooter = () => {
        return (
            <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                <Button style={{color: "#0050B3", cursor: "pointer"}}
                        onClick={() => this.setState({visible: false})}>关闭</Button>
            </div>
        )
    }

    render() {
        const columns = this.getColumns();
        return (
            <>
                <Modal
                    title={`字段表${this.state.positionItem?.name ? "-" + this.state.positionItem.name : ""}`}
                    visible={this.state.visible}
                    onCancel={() => {
                        this.setState({
                            visible: false,
                        })
                    }}
                    width={800}
                    footer={this.renderFooter()}
                    destroyOnClose={true}
                    centered={true}
                    maskClosable={false}
                >
                    <Scrollbars autoHide autoHeight autoHeightMax={600}>
                        {fieldsTable.map((item, index) => {
                            return (
                                <div key={index} style={{marginBottom: 20}}>
                                    <div style={{marginBottom: 10, fontWeight: "bold", fontSize: 16}}>{item.title}</div>
                                    <div style={{padding: "0 10px"}}>
                                        <TableTemplate
                                            key={item.key}
                                            maxWidth={getMaxWidth(this.pageMargin * 2 + this.pagePadding * 2)}
                                            maxHeight={this.tableHeight}
                                            columns={columns}
                                            dataSource={this.state.groupedData[item.type]}
                                            onResize={(offsetHeight) => {
                                                if (this.tableHeaderHeight != offsetHeight) {
                                                    this.tableHeaderHeight = offsetHeight;
                                                    this.setState({});
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            )
                        })}
                    </Scrollbars>
                </Modal>
            </>
        );
    }
}